import { createSlice } from "@reduxjs/toolkit";

export const PermissionReducer = createSlice({
  name: "permission",
  initialState: { permissions: JSON.parse(localStorage.getItem("permissions")) || [] },
  reducers: {
     modifyPermission:(state,action)=>{
        console.log("action.payload",action.payload)
        return{...state,permissions:action.payload}
     },
     getPermission:(state,action)=>{
      return{...state,permissions:action.payload}
     }
  },
});

export const { modifyPermission,getPermission } = PermissionReducer.actions;

export default PermissionReducer.reducer;
